import React from 'react';
import PropTypes from 'prop-types';
import { Card as AntCard } from 'antd';
import Icon from '../layout/Icon';

class Card extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    loading: PropTypes.bool,
    actions: PropTypes.node,
    bordered: PropTypes.bool,
    headStyle: PropTypes.shape({}),
    style: PropTypes.shape({}),
    children: PropTypes.node.isRequired,
    collapsible: PropTypes.bool,
    initialCollapse: PropTypes.bool,
  };

  static defaultProps = {
    title: null,
    actions: null,
    loading: false,
    bordered: true,
    style: {},
    headStyle: {},
    collapsible: false,
    initialCollapse: false,
  };

  state = { isCollapsed: false };

  componentDidMount() {
    this.setState({ isCollapsed: this.props.initialCollapse });
  }

  toggleCollapse = () => this.setState((prevState) => ({ isCollapsed: !prevState.isCollapsed }));

  render() {
    return (
      <AntCard
        className={this.state.isCollapsed ? 'collapsed' : ''}
        loading={this.props.loading}
        title={this.props.title}
        bordered={this.props.bordered}
        headStyle={this.props.headStyle}
        extra={
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {this.props.actions}
            {this.props.collapsible && (
              <Icon
                name={this.state.isCollapsed ? 'down-circle' : 'up-circle'}
                style={{ fontSize: 24 }}
                onClick={() => this.toggleCollapse()}
              />
            )}
          </div>
        }
        bodyStyle={this.props.style}
      >
        {this.props.children}
      </AntCard>
    );
  }
}

export default Card;
